module.exports = __webpack_public_path__ + "static/media/background2.852cd740.png";